import { render, staticRenderFns } from "./wtThumbnailConfirm.component.vue?vue&type=template&id=68bcfbe6&"
import script from "./wtThumbnailConfirm.component.vue?vue&type=script&lang=js&"
export * from "./wtThumbnailConfirm.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports